/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import VisibilitySensor from "react-visibility-sensor";
import { IAbsoluteMediaItemViewProps } from './absolute-media-item';

export default (props: IAbsoluteMediaItemViewProps) => {

    const { 
        obFFTitle1, 
        obFFContent1, 
        obFFImage1,
        links

    } = props;

    

    return (
       
        <div className="media-item">
            <div className="media-image">
                {obFFImage1}
            </div>
                <VisibilitySensor 
                    partialVisibility
                    offset={{bottom:100}}
                >
                {({isVisible}) =>
                    <div className={isVisible ? "animateThis textbox" : "textbox"}>
                        {obFFTitle1}
                        <div className="feature-content">{obFFContent1}</div>
                        {links}
                    </div>
                 } 
                 </VisibilitySensor> 
       
        </div>

    );
};
